import {
  Button,
  makeStyles,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../css/home.css";
import homeScreenImage from "../assests/homeScreen-image.png";
import pneumonia from "../assests/pneumonia-vector.png";
import { ExpandMore } from "@mui/icons-material";
import Global from "../utils/global";
import ReactLoading from "react-loading";

import Cookies from "universal-cookie";
const cookies = new Cookies();

const Home = () => {
  const navigate = useNavigate();
  const searchRef: any = useRef(null);
  const [diseases, setDiseases]: any = useState();
  const [filteredDisease, setFilteredDisease]: any = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    // if (!loading) {
    //   loading = true;
    //   console.log("Calling");
    //   // checkSession();
    // }
    // if (!checkingSess && !Global.token) {
    //    setCheckingSess(true);
    //    Global.checkSession().then((res) => {
    //       if (res) {
    //          setCheckingSess(false);
    //          getAllDiseases();
    //       } else {
    //          navigate("/");
    //       }
    //    });
    // } else
    if (!diseases && Global.token) {
      getAllDiseases();
    }
  }, []);

  const scrollDown = () => {
    window.scrollTo({
      top: searchRef.current.offsetTop,
      behavior: "smooth",
    });
  };

  const getAllDiseases = async () => {
    setIsLoading(true);
    const data = await Global.httpGET("disease");
    // console.log(data);
    if (data) {
      setDiseases(data);
      setFilteredDisease(data);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    if (!diseases) return;
    if (searchText === "") {
      return setFilteredDisease(diseases);
    }
    let filter = diseases.filter((data: any) => {
      return data.name.toLowerCase().includes(searchText.toLowerCase());
    });

    setFilteredDisease(filter);
  };

  return (
    <div className="homeScreen">
      <div className="homeScreen-additional-info">
        <img src={homeScreenImage} className="homeScreen-image" />
        <Typography className="homeScreen-text">
          Everyone Deserves to be Happy
        </Typography>
      </div>
      <div className="dropdown-container">
        <IconButton onClick={scrollDown} style={{ alignSelf: "baseline" }}>
          <ExpandMore className="dropdown-icon" />
        </IconButton>
      </div>
      <div className="homeScreen-search" ref={searchRef}>
        <input
          className="search-box"
          placeholder="Type here"
          type="text"
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearch();
            }
          }}
        />

        <Button
          className="search-button"
          variant="contained"
          onClick={() => handleSearch()}
        >
          Search
        </Button>
      </div>
      {/* change (not for Hetvi) - remove this height */}
      {isLoading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <ReactLoading
            type="bubbles"
            color={"black"}
            height={100}
            width={100}
          />
        </div>
      ) : (
        <div className="dieases-tabs">
          <div className="row-1-tabs">
            {filteredDisease && filteredDisease[0]
              ? filteredDisease.map((ele: any) => (
                  <div
                    className="dieases-1-tab"
                    onClick={() => {
                      navigate("/diagnose", {
                        state: { disease_id: ele.id },
                      });
                    }}
                  >
                    <img src={pneumonia} className="dieases-1-image" />
                    <Typography className="dieases-1-tab-text">
                      {ele.name}
                    </Typography>
                  </div>
                ))
              : null}
          </div>
        </div>
      )}
      {/* <Button
            onClick={() => {
               navigate("/flowchart");
            }}
         >
            Flowchart
         </Button> */}
    </div>
  );
};

export default Home;
